import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["currentPage", "totalPages", "onPrev", "onNext", "onPageChange", "isDark", "dark", "isWhite", "white", "className", "htmlProps"];
import { forwardRef } from 'react';
import cn from 'classnames';
import { ArrowLeft, ArrowRight, FirstPage, LastPage } from '@crehana/icons/outline';
import IconButton from "../../Buttons/IconButton";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Alternative = function Alternative(_ref, ref) {
  var _ref$currentPage = _ref.currentPage,
    currentPage = _ref$currentPage === void 0 ? 1 : _ref$currentPage,
    _ref$totalPages = _ref.totalPages,
    totalPages = _ref$totalPages === void 0 ? 1 : _ref$totalPages,
    onPrev = _ref.onPrev,
    onNext = _ref.onNext,
    onPageChange = _ref.onPageChange,
    isDark = _ref.isDark,
    dark = _ref.dark,
    isWhite = _ref.isWhite,
    white = _ref.white,
    className = _ref.className,
    htmlProps = _ref.htmlProps,
    alternativePaginationProps = _objectWithoutProperties(_ref, _excluded);
  var onFirst = function onFirst() {
    if (typeof onPageChange === 'function') {
      onPageChange(1);
    }
  };
  var onLast = function onLast() {
    if (typeof onPageChange === 'function') {
      onPageChange(totalPages);
    }
  };
  var labelClassNames = cn('font-body3 text-nowrap', dark ? 'text-base-lighter' : 'text-gray-dark');
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    className: cn('w-full sm:w-auto flex items-center justify-center sm:justify-start', className)
  }, alternativePaginationProps), htmlProps), {}, {
    children: [/*#__PURE__*/_jsx(IconButton, {
      className: "sm:hidden",
      customIcon: FirstPage,
      withoutBorders: true,
      isDark: isDark || dark,
      isWhite: isWhite || white,
      disabled: currentPage <= 1,
      onClick: onFirst
    }), /*#__PURE__*/_jsx(IconButton, {
      className: "ml-8 sm:hidden",
      customIcon: ArrowLeft,
      withoutBorders: true,
      isDark: isDark || dark,
      isWhite: isWhite || white,
      disabled: currentPage <= 1,
      onClick: onPrev
    }), /*#__PURE__*/_jsx(IconButton, {
      className: "hidden sm:inline-flex",
      customIcon: FirstPage,
      isDark: isDark || dark,
      isWhite: isWhite || white,
      disabled: currentPage <= 1,
      onClick: onFirst
    }), /*#__PURE__*/_jsx(IconButton, {
      className: "hidden ml-8 sm:inline-flex",
      arrow: "left",
      isDark: isDark || dark,
      isWhite: isWhite || white,
      disabled: currentPage <= 1,
      onClick: onPrev
    }), /*#__PURE__*/_jsx("span", {
      className: cn(labelClassNames, 'ml-12 sm:ml-24'),
      children: "P\xE1gina"
    }), /*#__PURE__*/_jsx("span", {
      className: "font-subtitle3 mx-8 ".concat(dark ? 'text-white' : 'text-base-main'),
      children: currentPage
    }), /*#__PURE__*/_jsx("span", {
      className: cn(labelClassNames, 'mr-12 sm:mr-24'),
      children: "de ".concat(totalPages)
    }), /*#__PURE__*/_jsx(IconButton, {
      className: "mr-8 sm:hidden",
      customIcon: ArrowRight,
      withoutBorders: true,
      isDark: isDark || dark,
      isWhite: isWhite || white,
      disabled: currentPage >= totalPages,
      onClick: onNext
    }), /*#__PURE__*/_jsx(IconButton, {
      className: "sm:hidden",
      customIcon: LastPage,
      withoutBorders: true,
      isDark: isDark || dark,
      isWhite: isWhite || white,
      disabled: currentPage >= totalPages,
      onClick: onLast
    }), /*#__PURE__*/_jsx(IconButton, {
      className: "hidden mr-8 sm:inline-flex",
      arrow: "right",
      isDark: isDark || dark,
      isWhite: isWhite || white,
      disabled: currentPage >= totalPages,
      onClick: onNext
    }), /*#__PURE__*/_jsx(IconButton, {
      className: "hidden sm:inline-flex",
      customIcon: LastPage,
      isDark: isDark || dark,
      isWhite: isWhite || white,
      disabled: currentPage >= totalPages,
      onClick: onLast
    })]
  }));
};
export default /*#__PURE__*/forwardRef(Alternative);